import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteACompany, loadCompanysData, saveACompany, updateACompany} from "../../redux/modules/company";
import {
	deleteACompanyproperty,
	loadCompanypropertysData,
	saveACompanyproperty,
	updateACompanyproperty,
	clearCompanyPropertyErrorMsg
} from "../../redux/modules/companyproperty";
import {
	deleteAPropertyvehicle,
	loadPropertyvehiclesData,
	saveAPropertyvehicle,
	updateAPropertyvehicle,
	clearPropertyVehicleErrorMsg
} from "../../redux/modules/propertyvehicle";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import GridList from "@material-ui/core/GridList";
import CardVehicleInformation from "./CardVehicleInformation";
import CardCompanyInformation from "./CardCompanyInformation";
import CardCompanyPropertyInformation from "./CardCompanyPropertyInformation";
import * as MainConstants from "../../utils/MainConstants";
import FormHelperText from "@material-ui/core/FormHelperText";
import Divider from "@material-ui/core/Divider";
//import {loadLocationsData} from "../../redux/modules/location";
import DeleteIcon from '@material-ui/icons/Delete';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
//import MaskedInput from 'react-text-mask';
import InputMask from 'react-input-mask'
import IconButton from '@material-ui/core/IconButton';
import CommentIcon from '@material-ui/icons/Comment';
import ExpandableCompanyPropertyInformation from "./ExpandableCompanyPropertyInformation";
import CardPrivatePropertyVehicleInformation from "./CardPrivatePropertyVehicleInformation";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {decodeVin} from "../../redux/modules/vin";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';


const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400, marginLeft: 'auto', marginRight: 'auto',
		},
	}, paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	}, avatar: {
		margin: theme.spacing.unit, backgroundColor: theme.palette.secondary.main,
	}, form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	}, submit: {
		marginTop: theme.spacing.unit * 3,
	}, formControl: {
		margin: theme.spacing.unit, minWidth: 120,
	}, selectEmpty: {
		marginTop: theme.spacing.unit * 2,
	}, button: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		backgroundColor: "#e2580d",
		//backgroundColor:"#2d93b3",
		color: "black",
		textTransform: "unset !important",
	}, gridList: {
		width:'90%',   height:'100%',
	}, dividerColor: {
		//marginTop: theme.spacing.unit * 3,
		color: "#7b32a8", backgroundColor: "#7b32a8",
	}, purplebutton: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		//backgroundColor: "#8a4e8a",
		backgroundColor:"#2d93b3",
		color: "black",
		textTransform: "unset !important",
	},
	
	vehiclebutton: {
		marginTop: theme.spacing.unit * 2,
		marginLeft: theme.spacing.unit,
		backgroundColor: "#2d93b3",
		color: "black",
		textTransform: "unset !important",
	},
	
	
	root: {
		width: '100%', maxWidth: 360, backgroundColor: theme.palette.background.paper,
	}, button2: {
		marginTop: theme.spacing.unit * 1,
		marginBottom: theme.spacing.unit*4,
		marginLeft: theme.spacing.unit * 2,
		//backgroundColor: "#2366f1",
		backgroundColor: "#2d93b3",
		fontSize: theme.typography.pxToRem(16),
		fontWeight:550,
		color: "black",
		textTransform: "unset !important",
	},
	
});


/*
private String id;
	private String ein;
	private String userId;
	private String name;
	private String address1;
	private String address2;
	private String city;
	private String state;
	private String country;
	private String zipCode;
	private String type;
	private String phone;
	private String email;
 */

//const tempConst=[{"name":"Haji", "phone":"617-234-2322"}, {"name":"Fredo Khand", "phone":"617-999-3433"}]
class ManagedPropertyInfoForm extends React.Component {
	
	
	state = {
		
		//selectedLocation:{},
		selectedProperty: {"id":""},
		selectedState: "Massachusetts",
		selectedCountry: "U.S.A",
		selectedCompany: {},
		inputFieldShrinkState: true,
		numberShrink: false, //Jut sfor alter I can add a shrink flag for each filed.
		checked: [],
		selectedListOfAuthorizedPeople: [],
		selectedListOfVehicleForProperty: [],
		selectedAuthPhone: "",
		selectedAuthName: "",
		showCompanyPropertySavedDialog: false,
		selectedVehicle: {"country": "U.S.A", "state": "Massachusetts"},
		
	};
	
	/*
	
	private String id;
private String accountName;
private String accountNumber;
private String bankName;
private String address1;
private String address2;
private String city;
private String state;
private String country;
private String zipCode;
private String accountRoutingNumber;
private String companyId;
private String userId;
private String phone;
	
	 */
	
	constructor(props) {
		super(props);
		this.companyCardList = null;
		this.editRecord = this.editRecord.bind(this);
		this.deleteRecord = this.deleteRecord.bind(this);
		this.clearFields = this.clearFields.bind(this);
		this.refresh = this.refresh.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
		//this.handleCompanyNumberChange = this.handleCompanyNumberChange.bind(this);
		this.handleNameChange = this.handleNameChange.bind(this);
		this.handleAddress1Change = this.handleAddress1Change.bind(this);
		//this.handleBankNameChange = this.handleBankNameChange.bind(this);
		
		this.handleAddress2Change = this.handleAddress2Change.bind(this);
		
		this.handleCityChange = this.handleCityChange.bind(this);
		this.handleStateChange = this.handleStateChange.bind(this);
		this.handleCountryChange = this.handleCountryChange.bind(this);
		this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handleLocationChange = this.handleLocationChange.bind(this);
		//this.handlePhoneChange = this.handlePhoneChange.bind(this);
		
		this.handleFaxChange = this.handleFaxChange.bind(this);
		this.handleTypeChange = this.handleTypeChange.bind(this);
		this.handleTimeZoneChange = this.handleTimeZoneChange.bind(this);
		this.handleLogoChange = this.handleLogoChange.bind(this);
		this.handleCompanyChange = this.handleCompanyChange.bind(this);
		this.handleStateSelectionChange = this.handleStateSelectionChange.bind(this);
		this.handleCountrySelectionChange = this.handleCountrySelectionChange.bind(this);
		this.handlePhoneChange = this.handlePhoneChange.bind(this);
		this.renderLitsOfAuthorizedPersons = this.renderLitsOfAuthorizedPersons.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
		this.handleAddAuthorizedPerson = this.handleAddAuthorizedPerson.bind(this);
		this.handleAuthNameChange = this.handleAuthNameChange.bind(this);
		this.handleAuthPhoneChange = this.handleAuthPhoneChange.bind(this);
		this.handleRemoveAuthorizedPerson = this.handleRemoveAuthorizedPerson.bind(this);
		this.getListOfCompanyPropertiesExpandable = this.getListOfCompanyPropertiesExpandable.bind(this);
		this.handleDecodeVin = this.handleDecodeVin.bind(this);
		
		let tempPeopleArray = [];
		if (this.state.selectedProperty.authorizedpeople != null) {
			tempPeopleArray = JSON.parse(this.state.selectedProperty.authorizedpeople);
		}
		
		this.setState({selectedListOfAuthorizedPeople: tempPeopleArray});
		this.handleClickShowSavedCompanyProperty = this.handleClickShowSavedCompanyProperty.bind(this);
		this.handleClickShowSavedCompanyPropertyClose = this.handleClickShowSavedCompanyPropertyClose.bind(this);
		this.handleVINChange = this.handleVINChange.bind(this);
		this.handleDecodeVin = this.handleDecodeVin.bind(this);
		this.handleBodyChange = this.handleBodyChange.bind(this);
		this.handleVehicleTypeChange = this.handleVehicleTypeChange.bind(this);
		this.handleVehicleStateChange = this.handleVehicleStateChange.bind(this);
		this.handlePlatenumberChange = this.handlePlatenumberChange.bind(this);
		this.handleVehicleCountrySelectionChange = this.handleVehicleCountrySelectionChange.bind(this);
		this.handleVehicleStateSelectionChange = this.handleVehicleStateSelectionChange.bind(this);
		this.handleVipCheckBoxChange = this.handleVipCheckBoxChange.bind(this);
		this.handleColorChange = this.handleColorChange.bind(this);
		this.handleRemoveVehicleForProperty = this.handleRemoveVehicleForProperty.bind(this);
		this.handleAddVehicleForProperty = this.handleAddVehicleForProperty.bind(this);
		//this.renderListOfVehicleForProperty = this.renderListOfVehicleForProperty.bind(this);
		this.getListOfVehicles = this.getListOfVehicles.bind(this);
		this.deleteVehicleRecord = this.deleteVehicleRecord.bind(this);
		this.handleUpdateWithAuthorizedPeople = this.handleUpdateWithAuthorizedPeople.bind(this);
		
		
	}
	
	handleVehicleStateSelectionChange(event) {
		//this.setState({selectedState: event.target.value});
		this.setState(Object.assign(this.state.selectedVehicle, {state: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handleVehicleCountrySelectionChange(event) {
		this.setState(Object.assign(this.state.selectedVehicle, {country: event.target.value}));
		
	}
	
	handleModelChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.props.decodedVinVehicleObject.model, {model: event.target.value}));
	}
	
	handleMakeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.props.decodedVinVehicleObject.make, {make: event.target.value}));
	}
	
	handleBodyChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.props.decodedVinVehicleObject.body, {body: event.target.value}));
	}
	
	handleVehicleTypeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.props.decodedVinVehicleObject.type, {type: event.target.value}));
	}
	
	handleYearChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedVehicle, {year: event.target.value}));
	}
	
	
	handleColorChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedVehicle, {color: event.target.value}));
	}
	
	handlePlatenumberChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedVehicle, {platenumber: event.target.value}));
	}
	
	handleVINChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedVehicle, {vin: event.target.value}));
	}
	
	
	handleVehicleStateChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedVehicle, {state: event.target.value}));
	}
	
	
	handleVipCheckBoxChange(event) {
		//event.preventDefault();
		console.log("handleVipCheckBoxChange: is called");
		console.log("handleVipCheckBoxChange: The checked value is " + event.target.value);
		this.setState(Object.assign(this.state.selectedVehicle, {vip: event.target.value}));
	}
	
	
	handleDecodeVin() {
		let {decodeVin} = this.props;
		decodeVin(this.state.selectedVehicle.vin);
	}
	
	handleClickShowSavedCompanyProperty() {
		this.setState({showCompanyPropertySavedDialog: true});
	};
	
	
	handleClickShowSavedCompanyPropertyClose() {
		let {clearCompanyPropertyErrorMsg} = this.props;
		this.setState({showCompanyPropertySavedDialog: false});
		clearCompanyPropertyErrorMsg();
	};
	
	
	handleAuthNameChange(event) {
		//event.preventDefault();
		this.setState(Object.assign({selectedAuthName: event.target.value}));
	}
	
	handleAuthPhoneChange(event) {
		//event.preventDefault();
		this.setState(Object.assign({selectedAuthPhone: event.target.value}));
	}
	
	handleAddAuthorizedPerson(value) {
		//JASON STRING OPERATION, ON HOW TO CHANGE AN ARRAY TO STRING AND
		//CHANGE THE STRING TO ARRAY - NEXT TWO LINES
		var myJSONString = JSON.stringify(this.state.selectedListOfAuthorizedPeople);
		let myJsonarray = JSON.parse(myJSONString);
		
		
		let tempPerson = {};
		tempPerson.name = this.state.selectedAuthName;
		tempPerson.phone = this.state.selectedAuthPhone;
		let tempArray = this.state.selectedListOfAuthorizedPeople;
		tempArray.push({"name": this.state.selectedAuthName, "phone": this.state.selectedAuthPhone})
		this.setState({selectedListOfAuthorizedPeople: tempArray});
		this.handleUpdateWithAuthorizedPeople(tempArray);
		
		
	};
	
	handleAddVehicleForProperty(value) {
		let {clearPropertyVehicleErrorMsg, saveAPropertyvehicle} = this.props;
		
		//JASON STRING OPERATION, ON HOW TO CHANGE AN ARRAY TO STRING AND
		//CHANGE THE STRING TO ARRAY - NEXT TWO LINES
		var myJSONString = JSON.stringify(this.state.selectedListOfVehicleForProperty);
		let myJsonarray = JSON.parse(myJSONString);
		let tempPerson = {};
		let vip = "No";
		if ((this.state.selectedVehicle.vip == null) || (this.state.selectedVehicle.vip === false)) {
			vip = "No";
		} else {
			vip = "Yes"
			
		}
		
		console.log("The VIP is " + vip);
		tempPerson.name = this.state.selectedAuthName;
		tempPerson.phone = this.state.selectedAuthPhone;
		let tempArray = this.state.selectedListOfVehicleForProperty;
		let newVehicle = {
			"vin": this.state.selectedVehicle.vin,
			"body": this.props.decodedVinVehicleObject.body,
			"type": this.props.decodedVinVehicleObject.type,
			"make": this.props.decodedVinVehicleObject.make,
			"model": this.props.decodedVinVehicleObject.model,
			"year": this.props.decodedVinVehicleObject.year,
			"color": this.state.selectedVehicle.color,
			"platenumber": this.state.selectedVehicle.platenumber,
			"country": this.state.selectedVehicle.country,
			"state": this.state.selectedVehicle.state,
			"vip": vip,
			"privatepropertyid": this.state.selectedProperty.id
		};
		//tempArray.push(newVehicle);
		saveAPropertyvehicle(DEFAULT_VESPAAN_SERVER.url, newVehicle, this.state.selectedCompany.id);
		
		
		//this.setState({selectedListOfVehicleForProperty: tempArray});
	};
	
	handleRemoveVehicleForProperty(value) {
		let {clearPropertyVehicleErrorMsg, deleteAPropertyvehicle} = this.props;
		
		let tempPerson = {};
		//ArrA.filter(n => !ArrB.includes(n));
		
		let tempArray = this.state.selectedListOfVehicleForProperty;
		let tempCheckedArray = this.state.checked;
		let filteredArray = tempArray.filter(n => !tempCheckedArray.includes(n))
		//tempArray.push({"name":this.state.selectedAuthName, "phone":this.state.selectedAuthPhone })
		
		this.setState({selectedListOfVehicleForProperty: filteredArray});
		//Farshid  deleteAPropertyvehicle(DEFAULT_VESPAAN_SERVER.url,  newVehicle, this.state.selectedCompany.id))
		
		
		
	};
	
	
	handleRemoveAuthorizedPerson(value) {
		let tempPerson = {};
		//ArrA.filter(n => !ArrB.includes(n));
		
		let tempArray = this.state.selectedListOfAuthorizedPeople;
		let tempCheckedArray = this.state.checked;
		let filteredArray = tempArray.filter(n => !tempCheckedArray.includes(n))
		console.log("The filteredArray is ");
		console.log(filteredArray);
		//tempArray.push({"name":this.state.selectedAuthName, "phone":this.state.selectedAuthPhone })
		
		this.setState({selectedListOfAuthorizedPeople: filteredArray});
		this.handleUpdateWithAuthorizedPeople(filteredArray);
	};
	
	handleToggle(value) {
		const currentIndex = this.state.checked.indexOf(value);
		const newChecked = this.state.checked;
		
		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}
		
		//setChecked(newChecked);
		this.setState({checked: newChecked});
	};
	
	
	handleSubmit() {
		
		
		let {saveACompanyproperty} = this.props;
		
		
		var tempStream = this.state.selectedProperty;
		//tempStream.locationId= this.state.selectedLocation.id;
		tempStream.state = this.state.selectedState;
		tempStream.country = this.state.selectedCountry
		//convert the array to string and then add it to the object being sent to the server
		var myJSONString = JSON.stringify(this.state.selectedListOfAuthorizedPeople);
		tempStream.authorizedpeople = myJSONString;
		if ((tempStream.address2 == null) || (tempStream.address2.length == 0)) {
			tempStream.address2 = "  ";
		}
		saveACompanyproperty(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
		
	};
	
	handleUpdate() {
		let {updateACompanyproperty} = this.props;
		
		var tempStream = this.state.selectedProperty;
		tempStream.state = this.state.selectedState;
		tempStream.country = this.state.selectedCountry
		var myJSONString = JSON.stringify(this.state.selectedListOfAuthorizedPeople);
		tempStream.authorizedpeople = myJSONString;
		updateACompanyproperty(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		
	};
	
	handleUpdateWithAuthorizedPeople(authorizedPeopleList) {
		let {updateACompanyproperty} = this.props;
		
		var tempStream = this.state.selectedProperty;
		tempStream.state = this.state.selectedState;
		tempStream.country = this.state.selectedCountry
		var myJSONString = JSON.stringify(authorizedPeopleList);
		tempStream.authorizedpeople = myJSONString;
		updateACompanyproperty(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		
	};
	
	handleZipcodeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {zipcode: event.target.value}));
	}
	
	handleCountryChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {country: event.target.value}));
	}
	
	handleStateChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {state: event.target.value}));
	}
	
	
	handleCityChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {city: event.target.value}));
	}
	
	handleAddress2Change(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {address2: event.target.value}));
	}
	
	handleAddress1Change(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {address1: event.target.value}));
	}
	
	/* handleCompanyNumberChange(event) {
			 //event.preventDefault();
			 this.setState(Object.assign(this.state.selectedProperty,{firstName:event.target.value}));
	 }
			 */
	
	handleNameChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {name: event.target.value}));
	}
	
	/*handleCompanyNameChange(event) {
			//event.preventDefault();
			this.setState(Object.assign(this.state.selectedProperty,{accountName:event.target.value}));
	}*/
	
	handleEmailChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {email: event.target.value}));
	}
	
	handleCompanyChange(event) {
		let {loadCompanypropertysData} = this.props;
		//event.preventDefault();
		this.setState({selectedCompany: event.target.value});
		loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
		this.setState({numberShrink: true});
		
	}
	
	handleStateSelectionChange(event) {
		//let { loadCompanypropertysData  } = this.props;
		//event.preventDefault();
		this.setState({selectedState: event.target.value});
		//loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
		this.setState({numberShrink: true});
	}
	
	handleCountrySelectionChange(event) {
		//let { loadCompanypropertysData  } = this.props;
		//event.preventDefault();
		this.setState({selectedCountry: event.target.value});
		//loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
	}
	
	handleFaxChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {fax: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handleTypeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {type: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handleTimeZoneChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {timezone: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handleLogoChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {companylogolink: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handlePhoneChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedProperty, {phone: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	
	handleLocationChange(event) {
		//event.preventDefault();
		this.setState({selectedLocation: event.target.value});
		//this.setState({selectedVideoControllerName: event.target.value.displayName});
	}
	
	
	clearFields = (e) => {
		e.preventDefault();
		this.setState(state => ({
			inputFieldShrinkState: true
		}));
		
		let tempPeopleArray = [];
		let tempObject = "";
		var tempSelectedCompany = Object.assign({}, this.state.selectedProperty);
		Object.keys(tempSelectedCompany).map((key, index) => {
			tempSelectedCompany[key] = "";
		});
		this.setState({selectedProperty: tempSelectedCompany})
		this.setState({selectedListOfAuthorizedPeople: tempPeopleArray});
		this.setState({selectedAuthName: tempObject});
		this.setState({selectedAuthPhone: tempObject});
		
	};
	
	
	renderErrorFiled(data) {
	
	
	}
	
	refresh(event) {
		let {loadCompanypropertysData} = this.props;
		loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
	}
	
	getListOfCompanyProperties() {
		let tempArray = this.props.companypropertysArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				return (<CardCompanyPropertyInformation info={s} onEdit={this.editRecord}
				                                        VehicleCounts={this.state.selectedListOfVehicleForProperty.length}
				                                        onDelete={this.deleteRecord}></CardCompanyPropertyInformation>);
			});
		}
		return (returnArray);
	}
	
	deleteVehicleRecord(argPropertyVehicleId) {
		//alert('I am deleting ' + argCameraId);
		let {deleteAPropertyvehicle} = this.props;
		deleteAPropertyvehicle(DEFAULT_VESPAAN_SERVER.url, argPropertyVehicleId, this.state.selectedCompany.id);
	}
	
	
	//This is for making teh police cards expanadble.
	getListOfCompanyPropertiesExpandable() {
		let tempArray = [] ; //this.props.companypropertysArray;
		//let tempArray = this.props.companypropertysArray;
		
		this.props.companypropertysArray.forEach((item) => {
			if (!tempArray.includes(item)) {
				tempArray.push(item);
			}
		});
		console.log("Farshid there are these many properties in the list " +tempArray.length);
		 //this.props.towjobsArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				/* return(

	 <CardTowJobInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardTowJobInformation>
	);
});*/
				return (
					<div style={{paddingBottom:10}}><ExpandableCompanyPropertyInformation info={s} key={s.id} onEdit={this.editRecord}
				                                              VehicleCounts={this.state.selectedListOfVehicleForProperty.length}
				                                              onVehicleOwnerText={this.vehicleOwnerTextMode}
				                                              onTowAgentText={this.towAgentTextMode}
				                                              onDelete={this.deleteRecord}></ExpandableCompanyPropertyInformation></div>);
			});
			//Duplicating array for testing only.
			//returnArray = returnArray.concat(returnArray);
			
		}
		return (returnArray);
	}
	
	
	getListOfCompaniesForSelection() {
		let tempArray = this.props.companysArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				return (<MenuItem key={s.id} value={s}>{s.name}</MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
		}
		return (returnArray);
	}
	
	
	render() {
		const {classes} = this.props;
		let usStates = MainConstants.getUSStates();
		let canStates = MainConstants.getCanadaStates();
		let availableCountries = MainConstants.getCountries();
		this.companyPropertyCardList = this.getListOfCompanyPropertiesExpandable(); //this.getListOfCompanyProperties();
		this.companySelectList = this.getListOfCompaniesForSelection();
		let personsList = this.renderLitsOfAuthorizedPersons();
		//let vehicleList = this.renderListOfVehicleForProperty();
		let vehicleList = this.getListOfVehicles();
		//Remove thsi Farshid Just for testing
		//this.companyPropertyCardList.length=5;
		
		return (<React.Fragment>
		 
					<Typography variant="h6" gutterBottom>
						Managed Property Information for {this.state.selectedProperty.name}
					</Typography>
			 
				<Grid container spacing={24}>
					<Grid item xs={12} sm={12}>
						
						<Grid container>
							
							<Grid item xs={6} sm={6}>
								{/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}
								
								{/*
            <Grid container >
                <Grid item xs={5} sm={5} >
                    <TextField required id="number" name="number"  label="Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedProperty.accountNumber} onChange={this.handleNumberChange}/>
                </Grid>
                <Grid item xs={2} sm={2} >
                </Grid>
                <Grid item xs={5} sm={5} >
                    <TextField required id="name" name="name"  label="Name on the account"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.accountName} onChange={this.handleCompanyNameChange}/>
                </Grid>
            </Grid>
            */}
								
								<Grid container>
									<Grid item xs={5} sm={5}>
										<TextField required id="name" name="name" label="Name" fullWidth
										           InputLabelProps={{shrink: this.state.inputFieldShrinkState,
											           /*style: {
												           fontFamily: 'Roboto Mono',
												           fontSize: 24,
												           color:'red',
												           fontWeight: 500,
											           }*/
											           }}
										           
										           InputProps={{
											           style: {
												           fontFamily: 'Roboto Mono',
												           fontSize: 24,
												           //color:'red',
												           fontWeight: 500,
											           }}}
										           value={this.state.selectedProperty.name} onChange={this.handleNameChange}/>
									</Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									<Grid item xs={5} sm={5}>
										<FormControl className={classes.formControl}>
											<InputLabel htmlFor="age-helper"> Select Tow Company </InputLabel>
											<Select
												value={this.state.selectedCompany}
												onChange={this.handleCompanyChange}
												useDefault={true}
												defaultValue={this.state.selectedCompany.name}
											>
												
												{this.companySelectList}
											
											</Select>
											<FormHelperText>Select a Company </FormHelperText>
										</FormControl>
									</Grid>
								</Grid>
								
								<Grid item xs={12}>
									<TextField required id="address1" name="address1" label="Address line 1" fullWidth
									           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
									           value={this.state.selectedProperty.address1} onChange={this.handleAddress1Change}/>
								</Grid>
								<Grid item xs={12}>
									<TextField id="address2" name="address2" label="Address line 2" fullWidth
									           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
									           value={this.state.selectedProperty.address2} onChange={this.handleAddress2Change}/>
								</Grid>
								<Grid container>
									
									<Grid item xs={5} sm={5}>
										
										<TextField required id="city" name="city" label="City" fullWidth
										           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
										           value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
									
									</Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									
									<Grid item xs={5} sm={5}>
										<FormControl className={classes.formControl}>
											<InputLabel htmlFor="age-helper">State</InputLabel>
											<Select value={this.state.selectedState}
											        onChange={this.handleStateSelectionChange}
											        inputProps={{
												        name: 'state', id: 'state-helper',
											        }}
											>
												
												{(this.state.selectedCountry === "U.S.A") && (usStates)}
												{(this.state.selectedCountry !== "U.S.A") && (canStates)}
											
											
											</Select>
											{/* <FormHelperText>Select a State </FormHelperText> */}
										</FormControl>
									
									</Grid>
									
									
									<Grid item xs={5} sm={5}>
										
										<TextField required id="zip" name="zip" label="Zip / Postal code" fullWidth
										           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
										           value={this.state.selectedProperty.zipcode} onChange={this.handleZipcodeChange}/>
									
									
									</Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									<Grid item xs={5} sm={5}>
										{/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                                           */}
										<FormControl className={classes.formControl}>
											<InputLabel htmlFor="age-helper">Country</InputLabel>
											<Select value={this.state.selectedCountry}
											        onChange={this.handleCountrySelectionChange}
											        inputProps={{
												        name: 'country', id: 'country-helper',
											        }}
											>
												
												{availableCountries}
											
											</Select>
										
										</FormControl>
									
									
									</Grid>
									
									
									<Grid item xs={5} sm={5}>
										<InputMask mask="(999) 999-9999"
										           value={this.state.selectedProperty.phone} onChange={this.handlePhoneChange}
										>
											{() => <TextField required id="phone" name="phone" label="Phone" fullWidth
											                  InputLabelProps={{shrink: this.state.inputFieldShrinkState}}/>}
										
										</InputMask>
									</Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									
									<Grid item xs={5} sm={5}>
										<TextField required id="email" name="email" type="email" label="Email"
										           placeholder="email@example.com" fullWidth
										           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
										           value={this.state.selectedProperty.email} onChange={this.handleEmailChange}/>
									</Grid>
									
									
									{/*  It didn't work.
                        <Grid item xs={5} sm={5}>
                            <InputMask mask="**************************************@********************************************************"
                            value={this.state.selectedProperty.email} onChange={this.handleEmailChange}
                            >
                            {()=> <TextField  required id="email"  name="email"  label="Email"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}    /> }

                        </InputMask>
                        </Grid>
                        */}
									
									
									<Grid item xs={5} sm={5}>
										<InputMask mask="(999) 999-9999"
										           value={this.state.selectedProperty.fax} onChange={this.handleFaxChange}>
											{() => <TextField required id="phone" name="Fax" label="Fax" fullWidth
											                  InputLabelProps={{shrink: this.state.inputFieldShrinkState}}/>}
										</InputMask>
									</Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									
									<Grid item xs={5} sm={5}>
										
										{/*   I moved it to the top
                    <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-helper">Company</InputLabel>
                    <Select value={this.state.selectedCompany}
                        onChange={this.handleCompanyChange}
                        inputProps={{
                            name: 'age',
                                id: 'age-helper',
                                }}
                            >

                                {this.companySelectList}

                            </Select>
                            <FormHelperText>Select a Company </FormHelperText>
                        </FormControl>  */}
									
									
									</Grid>
									<Grid item xs={6} sm={6}>
										{((this.state.selectedProperty.id === undefined) || (this.state.selectedProperty.id === "")) && (<Button style={{width:'80%'}} variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}>
											Add Property
										</Button>)}
									</Grid>
									<Grid item xs={6} sm={6}>
										{(  (this.state.selectedProperty.id !=='') ) && (
										<Button  style={{width:'80%'}} variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}>
											Update Property
										</Button>)}
									</Grid>
									<Grid item xs={6} sm={6}>
										
										<Button style={{width:'80%'}} variant="contained" color="primary" onClick={this.clearFields} className={classes.button}>
											Clear Fields
										</Button>
									</Grid>
									<Grid item xs={6} sm={6}>
										<Button style={{width:'80%'}} variant="contained" color="primary" onClick={this.refresh} className={classes.button}>
											Refresh
										</Button>
									</Grid>
									
									<Grid container>
										<Grid item xs={12} sm={12}>
											<br/>
											<Divider className={classes.dividerColor}></Divider>
											<br/>
										</Grid>
									</Grid>
									
									{((this.state.selectedProperty.id === undefined) || (this.state.selectedProperty.id !== "")) && (
									<Grid container spacing={24}>
										
										<Grid item xs={6} sm={6}>
											<Typography variant="body1" gutterBottom>
												Property Contact List
											</Typography>
											<TextField required id="person" name="Person" label="Name" fullWidth
											           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
											           value={this.state.selectedAuthName} onChange={this.handleAuthNameChange}/>
											<br/>
											<br/>
											
											
											<InputMask mask="(999) 999-9999"
											           value={this.state.selectedAuthPhone} onChange={this.handleAuthPhoneChange}>
												{() =><TextField mask="(999) 999-9999" required id="personPHONE" name="PersonPHONE" label="Phone" fullWidth
											           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
											          />}
											</InputMask>
											<Button style={{width:'40%', fontSize:18}} variant="contained" onClick={this.handleAddAuthorizedPerson}
											        className={classes.purplebutton}>
												Add Contact
											</Button>
											{((this.state.checked !== null) &&(this.state.checked.length !== 0) ) &&(
											<Button  style={{width:'40%', fontSize:16}}variant="contained" onClick={this.handleRemoveAuthorizedPerson}
											        className={classes.purplebutton}>
												Remove Contact
											</Button>)}
										
										</Grid>
										
										<Grid item xs={6} sm={6}>
											<Typography style={{marginLeft:12}} variant="body1" gutterBottom>
												Property Contact List: {this.state.selectedListOfAuthorizedPeople.length} people
											</Typography>
											
											{personsList}
										</Grid>
										
										{/*<Grid item xs={2} sm={2}>
											<Button variant="contained" onClick={this.handleAddAuthorizedPerson}
											        className={classes.purplebutton}>
												Add
											</Button>
											<Button variant="contained" onClick={this.handleRemoveAuthorizedPerson}
											        className={classes.purplebutton}>
												Remove
											</Button>
										</Grid>*/}
									</Grid>)}
									
									<Grid container>
										<Grid item xs={12} sm={12}>
											<br/>
											<Divider className={classes.dividerColor}></Divider>
											<br/>
										</Grid>
									</Grid>
									
									
									{((this.state.selectedProperty.id === undefined) || (this.state.selectedProperty.id !== "")) && (
									<Grid container spacing={24}>
										<Grid item xs={4} sm={4}>
											{/*<Typography variant="body1" gutterBottom>
												Property Vehicle List: {this.state.selectedListOfVehicleForProperty.length} vehicles
											</Typography>*/}
											
											<TextField id="vinnumber" name="vinnumber" label="VIN" fullWidth InputLabelProps={{shrink: true}}
											           value={this.state.selectedVehicle.vin} onChange={this.handleVINChange}/>
											<Button style={{width:'80%', fontSize:18}} variant="contained" color="primary" className={classes.button2}
											        onClick={(event) => this.handleDecodeVin()}>
												Decode VIN
											</Button>
											<TextField required id="body" name="body" label="Body" fullWidth InputLabelProps={{shrink: true}}
											           value={this.props.decodedVinVehicleObject.body} onChange={this.handleBodyChange}/>
											
											
											<TextField required id="make" name="make" label="Make" fullWidth InputLabelProps={{shrink: true}}
											           value={this.props.decodedVinVehicleObject.make} onChange={this.handleMakeChange}/>
											
											<TextField id="year" name="year" label="Year" fullWidth InputLabelProps={{shrink: true}}
											           value={this.props.decodedVinVehicleObject.year} onChange={this.handleYearChange}/>
											
											
											<TextField required id="type" name="type" label="Type" fullWidth InputLabelProps={{shrink: true}}
											           value={this.props.decodedVinVehicleObject.type} onChange={this.handleTypeChange}/>
											<TextField required id="model" name="model" label="Model" fullWidth
											           InputLabelProps={{shrink: true}} value={this.props.decodedVinVehicleObject.model}
											           onChange={this.handleModelChange}/>
											
											<FormControl className={classes.formControl}>
												<InputLabel htmlFor="age-helper">Country</InputLabel>
												<Select value={this.state.selectedVehicle.country}
												        onChange={this.handleVehicleCountrySelectionChange}
												        inputProps={{
													        name: 'country', id: 'country-helper',
												        }}
												>
													
													{availableCountries}
												
												</Select>
											</FormControl>
											<FormControl className={classes.formControl}>
												<InputLabel htmlFor="age-helper">State</InputLabel>
												<Select value={this.state.selectedVehicle.state}
												        onChange={this.handleVehicleStateSelectionChange}
												        inputProps={{
													        name: 'state', id: 'state-helper',
												        }}
												>
													
													{(this.state.selectedVehicle.country === "U.S.A") && (usStates)}
													{(this.state.selectedVehicle.country !== "U.S.A") && (canStates)}
												
												
												</Select>
												{/* <FormHelperText>Select a State </FormHelperText> */}
											</FormControl>
											<TextField id="plateNumber" name="plateNumber" label="PlateNumber" fullWidth
											           InputLabelProps={{shrink: true}} value={this.state.selectedVehicle.platenumber}
											           onChange={this.handlePlatenumberChange}/>
											
											
											<TextField required id="color" name="color" label="Color" fullWidth
											           InputLabelProps={{shrink: true}} value={this.state.selectedVehicle.color}
											           onChange={this.handleColorChange}/>
											<FormControlLabel style={{width:'100%'}}
												control={<Checkbox checked={this.state.selectedVehicle.vip} onChange={e => {
													//this.setState({ this.state.selectedVehicle.vip: e.target.checked });
													this.setState(Object.assign(this.state.selectedVehicle, {vip: e.target.checked}));
													//this.handleVipCheckBoxChange(e)
												}}
												                   value={this.state.selectedVehicle.vip}/>}
												label="VIP"
											/>
											<Button  style={{width:'100%', fontSize:18}} variant="contained" onClick={this.handleAddVehicleForProperty}
											        className={classes.vehiclebutton}>
												Add Vehicle to Property
											</Button>
										</Grid>
										{/*}
                <Grid item xs={3} sm={3} >
                      <Button variant="contained" color="primary" className={classes.button2} onClick={(event) => this.handleDecodeVin()} >
                    decode VIN
                    </Button>
        <TextField required id="type" name="type" label="Type" fullWidth InputLabelProps={{ shrink:true }} value={this.props.decodedVinVehicleObject.type} onChange={this.handleTypeChange} />
        <TextField required id="model" name="model" label="Model" fullWidth InputLabelProps={{ shrink: true }} value={this.props.decodedVinVehicleObject.model} onChange={this.handleModelChange} />
    
    
    
        <TextField required id="color" name="color" label="Color" fullWidth InputLabelProps={{ shrink: true }} value={this.state.selectedVehicle.color} onChange={this.handleColorChange} />
        <FormControlLabel
        control={
        <Checkbox checked={this.state.selectedVehicle.vip} onChange={()=>{this.handleVipCheckBoxChange} }value={this.state.selectedVehicle.vip}  />
        }
        label="VIP"
          />
    
                        <FormControl className={classes.formControl}>
                          <InputLabel htmlFor="age-helper">State</InputLabel>
                          <Select value={this.state.selectedVehicle.state}
                        onChange={this.handleVehicleStateSelectionChange}
                        inputProps={{
                            name: 'age',
                              id: 'age-helper',
                        }}
                    >
                    
                        {(this.state.selectedVehicle.country == "U.S.A") && (usStates)}
                        {(this.state.selectedVehicle.country != "U.S.A") && (canStates)}
                
                
                    </Select>
                    
                    </FormControl>
                     </Grid>
          */}
										
										<Grid item xs={7} sm={7} style={{marginLeft:2, marginRight:4}}>
											<Typography style={{marginLeft:12}} variant="body1" gutterBottom>
												Property Vehicle List: {this.state.selectedListOfVehicleForProperty.length} vehicles
											</Typography>
											<Paper style={{maxHeight:'80%', overflow: 'auto', marginLeft:10, width:'100%'}}>
												{vehicleList}
											</Paper>
										</Grid>
										
										{/*<Grid item xs={2} sm={2}>
											<Button variant="contained" onClick={this.handleAddVehicleForProperty}
											        className={classes.vehiclebutton}>
												Add Vehicle
											</Button>
										 
										</Grid>*/}
									</Grid>)}
									
									<Grid container>
										<Grid item xs={12} sm={12}>
											<br/>
											<Divider className={classes.dividerColor}></Divider>
											<br/>
										</Grid>
									</Grid>
									
									<Grid item xs={5} sm={5}>
									</Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									
									<Grid item xs={5} sm={5}>
										{/* empty for now we can later*/}
									</Grid>
									
									{/*}
									<Grid item xs={6} sm={6}>
										<Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}>
											Add Property
										</Button>
									</Grid>
									<Grid item xs={6} sm={6}>
										<Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}>
											Update Property
										</Button>
									</Grid>
									<Grid item xs={6} sm={6}>
										<Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}>
											Clear Fields
										</Button>
									</Grid>
									<Grid item xs={6} sm={6}>
										<Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}>
											Refresh
										</Button>
									</Grid>*/}
								</Grid>
							</Grid>
							<Grid item xs={1} sm={1}>
							</Grid>
							<Grid item xs={5} sm={5}>
								{/*<DynamicTable  data={this.props.companysArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable> */}
								<Typography variant="h6" gutterBottom>
									{this.props.companypropertysArray.length} Managed Properties in your profile.
								</Typography>
								<Grid container direction="column" spacing={2}>
									{/*<GridList cellHeight={30} className={classes.gridList} style={{maxHeight:'800'}}>*/}
									{this.companyPropertyCardList}
									{/*}</GridList>*/}
								</Grid>
							</Grid>
						</Grid>
						
						
						<Grid container>
							{/*{  (this.props.errorCMsg) && (this.props.errorCMsg.message) && (
                        <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Error - Operation Failed" value= {" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " +  this.props.errorCMsg.timestamp}
                            className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                        </Grid>)
                    } */}
							{/*
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                    */}
						</Grid>
					</Grid>
					{/* This is for submit event error/success display */}
					<Dialog
						open={this.state.showCompanyPropertySavedDialog}
						onClose={this.handleClickShowSavedCompanyPropertyClose}
						scroll={'paper'}
						classes={{
							paper: classes.formControl2,
						}}
						aria-labelledby="scroll-dialog-title"
						aria-describedby="scroll-dialog-description"
						maxWidth="xl"
					>
						<DialogTitle id="scroll-dialog-title">Property Information</DialogTitle>
						<DialogContent id="farshids" dividers="paper">
							
							{(this.props.errorCMsg.status == 200) && (<div>
								The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button
								- {this.props.errorCMsg.status} {this.props.errorCMsg.statusText}
							</div>)}
							{(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
								The Operation FAILED, please try again!
								- {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
							</div>)}
						
						</DialogContent>
						<DialogActions>
							{/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
							
							<Button onClick={this.handleClickShowSavedCompanyPropertyClose} color="secondary">Close</Button>
						</DialogActions>
					</Dialog>
				
				
				</Grid>
			</React.Fragment>);
	}//end of render
	
	
	editRecord(singleRowData) {
		//loadPropertyvehiclesData(argURL, argCompanyId, argPropertyId)
		let {loadPropertyvehiclesData} = this.props;
		
		let tempPeopleArray = [];
		this.setState({inputFieldShrinkState: true});
		this.setState({selectedProperty: singleRowData});
		this.setState({selectedState: singleRowData.state});
		this.setState({selectedCountry: singleRowData.country});
		if (singleRowData.authorizedpeople != null) {
			tempPeopleArray = JSON.parse(singleRowData.authorizedpeople);
		}
		
		this.setState({selectedListOfAuthorizedPeople: tempPeopleArray});
		
		loadPropertyvehiclesData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id, singleRowData.id)
		
		// this.setState({selectedListOfAuthorizedPeople:tempPeopleArray});
		//We need to change the seleted Location as well.
		//let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );
		
		//this.setState({selectedLocation:tempLocation });
		
	}
	
	
	deleteRecord(argProcessId) {
		//alert('I am deleting ' + argCameraId);
		let {deleteACompanyproperty} = this.props;
		deleteACompanyproperty(DEFAULT_VESPAAN_SERVER.url, argProcessId, this.state.selectedCompany.id);
	}
	
	
	componentWillMount() {
		let {loadCompanysData, loadLocationsData} = this.props;
		loadCompanysData(DEFAULT_VESPAAN_SERVER.url);
		//loadLocationsData("http://localhost:9065/" );
		
		this.setState({
			errorCMsg: {}
		});
		
		
	}
	
	componentWillReceiveProps(nextProps) {
		if (this.props.companysArray !== nextProps.companysArray) {
			this.setState({
				companysArray: nextProps.companysArray
			});
		}
		
		if (this.props.propertvehiclessArray !== nextProps.propertvehiclessArray) {
			this.setState({
				selectedListOfVehicleForProperty: nextProps.propertvehiclessArray
			});
		}
		
		if ((nextProps != null) && (nextProps.companysArray != null) && (nextProps.companysArray.length >= 1) && (this.props.companysArray !== nextProps.companysArray)) {
			this.setState({selectedCompany: nextProps.companysArray[0]});
			//selectACompany(nextProps.companysArray[0].id);
		}
		if (nextProps.errorCMsg.status != null) {
			if (nextProps.errorCMsg.status != null) {
				this.handleClickShowSavedCompanyProperty();
			}
		}
	}
	
	renderLitsOfAuthorizedPersons() {
		const {classes} = this.props;
		return (<List className={classes.root}>
				{this.state.selectedListOfAuthorizedPeople.map(value => {
					const labelId = `checkbox-list-label-${value}`;
					
					return (<ListItem key={value.name} role={undefined} dense button onClick={() => this.handleToggle(value)}>
							<ListItemIcon>
								<Checkbox
									edge="start"
									checked={this.state.checked.indexOf(value) !== -1}
									tabIndex={-1}
									disableRipple
									inputProps={{'aria-labelledby': labelId}}
								/>
							</ListItemIcon>
							<ListItemText id={labelId} primary={`Name: ${value.name}`} secondary={`Phone: ${value.phone}`}/>
							{/*<ListItemSecondaryAction>
                <IconButton edge="end" aria-label="comments">
                    <DeleteIcon />
                </IconButton>
                </ListItemSecondaryAction>
                */}
						
						</ListItem>);
				})}
			</List>);
	}
	
	getListOfVehicles() {
		//let tempArray = this.state.selectedListOfVehicleForProperty;
		let tempArray =[];
		let returnArray = [];
		this.state.selectedListOfVehicleForProperty.forEach((item) => {
			if (!tempArray.includes(item)) {
				tempArray.push(item);
			}
		});
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				return (<CardPrivatePropertyVehicleInformation info={s}
				                                               onDelete={this.deleteVehicleRecord}></CardPrivatePropertyVehicleInformation>);
			});
		}
		return (returnArray);
	}
	
	
	/*renderListOfVehicleForProperty() {
		const {classes} = this.props;
		return (<Paper style={{maxHeight: 400, overflow: 'auto'}}>
				<List className={classes.root}>
					{this.state.selectedListOfVehicleForProperty.map(value => {
						const labelId = `checkbox-list-label-${value}`;
						
						return (<ListItem key={value.vin} role={undefined} dense button onClick={() => this.handleToggle(value)}>
								<ListItemIcon>
									<Checkbox
										edge="start"
										checked={this.state.checked.indexOf(value) !== -1}
										tabIndex={-1}
										disableRipple
										inputProps={{'aria-labelledby': labelId}}
									/>
								</ListItemIcon>
								<ListItemText id={labelId} primary={`${value.platenumber},${value.state} `}
								              secondary={`Vin: ${value.vin} Color: ${value.color}  Make: ${value.Make} Model: ${value.make}`}/>
								 /////<ListItemSecondaryAction>
                <IconButton edge="end" aria-label="comments">
                    <DeleteIcon />
                </IconButton>
                </ListItemSecondaryAction>////////
                
							
							</ListItem>);
					})}
				</List>
			</Paper>);
	}*/
	
	
}//end of class

ManagedPropertyInfoForm.propTypes = {
	classes: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
	return {
		
		propertvehiclessArray: state.propertyvehicle.propertyvehiclesArray,
		PropertyVehicleDeleteResponse: state.propertyvehicle.deletePropertyvehicleResp,
		PropertyVehicleSaveResponse: state.propertyvehicle.savePropertyvehicleResp,
		
		companypropertysArray: state.companyproperty.companypropertysArray,
		CompanyPropertyDeleteResponse: state.companyproperty.deleteCompanypropertyResp,
		CompanyPropertySaveResponse: state.companyproperty.saveCompanypropertyResp,
		companysArray: state.company.companysArray,
		decodedVinVehicleObject: state.vin.decodedVinVehicleObject, //locationsArray:state.location.locationsArray,
		//vcArray:state.videocontroller.vcArray,
		//camerasArray:state.camera.camerasArray,
		errorCMsg: state.companyproperty.errorCMsg,
	};
};


const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		
		loadPropertyvehiclesData: loadPropertyvehiclesData,
		deleteAPropertyvehicle: deleteAPropertyvehicle,
		saveAPropertyvehicle: saveAPropertyvehicle,
		updateAPropertyvehicle: updateAPropertyvehicle,
		
		
		loadCompanypropertysData: loadCompanypropertysData,
		deleteACompanyproperty: deleteACompanyproperty,
		saveACompanyproperty: saveACompanyproperty,
		updateACompanyproperty: updateACompanyproperty,
		loadCompanysData: loadCompanysData,
		decodeVin: decodeVin,
		clearCompanyPropertyErrorMsg: clearCompanyPropertyErrorMsg,
		
	}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ManagedPropertyInfoForm));
